// extracted by mini-css-extract-plugin
export default {"welcomeBonus":"WelcomeBonus_welcomeBonus__Q37tO","block":"WelcomeBonus_block__4Q2gW","content":"WelcomeBonus_content__pr9JC","text":"WelcomeBonus_text__zRHhM"};